import { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from "react-materialize";
import { MdDeleteForever } from "react-icons/md";
import {
  fitTimeInDate
} from '../../common/addNewOrdersUtils';
import DateRangePicker from '../../common/DateRangePicker';
import PropertyList from '../PropertyList';
import OrderDetails from'../OrderDetails';
import OrderSummary from '../OrderSummary';

const OrderForm = ({
  translate,
  allOrders,
  timeLineLoadedDataRange,
  dataRange,
  orderData,
  isOrderEdit,
  handleFormData,
  handleSubmit,
  setIsRemoveOrderModal, // handle on Edit
  setOrderData, // To save Property click
  setDataRange
}) => {
  const [isDateAvailable, setIsDateAvailable] = useState(true);

  const isReserveButtonActive = orderData.firstName && orderData.phone && isDateAvailable;

  const handlePropertyClick = (property) => {
    setOrderData(prevState => ({ // Set Property data
      ...prevState,
      propertyId: property.propertyId,
      propertyName: property.propertyName,
      costPerNight: property.costPerNight
    }));
  };

  const handleDataRangeSelection = (date) => {
    if (date) {
      const selectedDate = {...date}
      selectedDate.startDate = fitTimeInDate(date.startDate)
      selectedDate.endDate = fitTimeInDate(date.endDate)

      setDataRange(selectedDate);
    }
  };

  return (
    <div className="order-view-wrap">
      <div className="flex-container">
        <div className="item-first">
          <DateRangePicker
            setDataRange={handleDataRangeSelection}
            translate={translate}
            dataRange={dataRange}
            isComponentDisabled={!orderData.propertyId}
            propertyId={orderData.propertyId}
            allOrders={allOrders}
            timeLineLoadedDataRange={timeLineLoadedDataRange}
            isOrderEdit={isOrderEdit}
            currentlyEditedOrderData={orderData}
            setIsDateAvailable={setIsDateAvailable}
            isDateAvailable={isDateAvailable}
          />
        </div>
        <div className="item-second">
          <PropertyList
            setData={handlePropertyClick}
            timeLineSelectedElementId={orderData.propertyId}
          />
        </div>
        <div className="item-third">
        <OrderDetails
          setData={handleFormData}
          orderData={orderData}
        />
        </div>
      </div>
      <OrderSummary
        setData={handleFormData}
        orderData={orderData}
        dataRange={dataRange}
        isOrderEdit={isOrderEdit}
      />
      <div className="buttons-wrap">
        <div className="submit-btn-wrap">
          <div className="btn-validation-message">{!isReserveButtonActive && translate('firstNameAndPhoneRequired')}</div>
          <Button
            className="submit-button"
            node="button"
            disabled={!isReserveButtonActive}
            onClick={handleSubmit}
          >
            {translate('save')}
          </Button>
        </div>
        {isOrderEdit ? 
          <MdDeleteForever
            className="remove-icons"
            size={'3.5em'}
            title={translate('remove')}
            onClick={() => setIsRemoveOrderModal(true)}
          />
          : null
        }
      </div>
    </div>
  )
};

OrderForm.propTypes = {
  translate: PropTypes.func.isRequired,
  dataRange: PropTypes.shape({
    dateFrom: PropTypes.instanceOf(Date),
    dateTo: PropTypes.instanceOf(Date)
  }).isRequired,
  orderData: PropTypes.shape({
    firstName: PropTypes.string,
    phone: PropTypes.string,
    propertyId: PropTypes.string
  }).isRequired,
  isOrderEdit: PropTypes.bool.isRequired,
  handleFormData: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  setIsRemoveOrderModal: PropTypes.func,
  timeLineNewItemData: PropTypes.shape({
    isTimeLineNewOrder: PropTypes.bool,
    isTimeLineEditOrder: PropTypes.bool,
    orderId: PropTypes.string,
    propertyName: PropTypes.string,
    clickedDate: PropTypes.instanceOf(Date)
  }),
  allOrders: PropTypes.arrayOf(
    PropTypes.shape({})
  ).isRequired,
  timeLineLoadedDataRange: PropTypes.shape({
    dateFrom: PropTypes.instanceOf(Date),
    dateTo: PropTypes.instanceOf(Date)
  }).isRequired,
  setDataRange: PropTypes.func.isRequired 
};

export default OrderForm;
